export const EMOTICON = [
  "angry",
  "best",
  "brushteeth",
  "default",
  "drinking",
  "duststorm",
  "fan",
  "fighting",
  "meat",
  "nono",
  "ok",
  "pig",
  "popcorn",
  "ppuwoo",
  "rice",
  "run",
  "sleep",
  "sparking",
  "surprised",
  "thump",
  "travel",
  "watching",
  "whatau",
  "whimper",
]
